module.exports = __webpack_public_path__ + "static/media/ania.3ca41556.jpg";